<template lang="pug">
  div
    VeeField(
      name="deliveryLiftSize"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="liftSizeValue"
        @input="handleLiftSize"
        custom-classes="!rounded-t-none !border-t-0"
        :options="getLiftSizeOptions"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.lift_size')"
        indicator
        qa-tag="sel_delivery_lift_size")
      VeeErrorMessage(name="deliveryLiftSize")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.lift_size') }}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapActions, mapGetters } from "vuex"
import {
  GET_DELIVERY_LIFT_AVAILABLE,
  GET_DELIVERY_LIFT_TYPE,
  SET_DELIVERY_LIFT_AVAILABLE,
  SET_DELIVERY_LIFT_TYPE
} from "~/store/listing"
import {
  LIFT_AVAILABLE,
  LIFT_UNAVAILABLE,
  LIFT_TYPE_NO_LIFT,
  LIFT_TYPE_STANDARD,
  LIFT_TYPE_LARGE,
  LIFT_TYPE_EXTRA_LARGE
} from "~/constants/listing"

export default defineComponent({
  name: "LiftAvailableDeliverySel",

  props: {},
  computed: {
    ...mapGetters("listing", {
      getDeliveryLiftAvailable: GET_DELIVERY_LIFT_AVAILABLE,
      getDeliveryLiftType: GET_DELIVERY_LIFT_TYPE,
    }),
    getLiftSizeOptions(): LiftSizeOption[] {
      return [
        {
          name: this.$t("location_form.lift_no_lift") as string,
          value: LIFT_TYPE_NO_LIFT
        },
        {
          name: this.$t("location_form.lift_small") as string,
          value: LIFT_TYPE_STANDARD
        },
        {
          name: this.$t("location_form.lift_medium") as string,
          value: LIFT_TYPE_LARGE
        },
        {
          name: this.$t("location_form.lift_large") as string,
          value: LIFT_TYPE_EXTRA_LARGE
        }
      ]
    },
    liftSizeValue(): string | null {
      if (this.getDeliveryLiftAvailable === LIFT_UNAVAILABLE) {
        return LIFT_TYPE_NO_LIFT
      }
      if (this.getDeliveryLiftAvailable === LIFT_AVAILABLE && this.getDeliveryLiftType) {
        return this.getDeliveryLiftType
      }
      return null
    },
  },
  methods: {
    ...mapActions("listing", {
      setLiftAvailable: SET_DELIVERY_LIFT_AVAILABLE,
      setLiftType: SET_DELIVERY_LIFT_TYPE
    }),
    handleLiftSize(value: string): void {
      if (value === LIFT_TYPE_NO_LIFT) {
        this.setLiftAvailable(LIFT_UNAVAILABLE)
        this.setLiftType(value)
      } else {
        this.setLiftAvailable(LIFT_AVAILABLE)
        this.setLiftType(value)
      }
    }
  }
})
</script>
